<script lang="ts">
export default {
  name: 'PoliciesCollapseView',
};
</script>

<script setup lang="ts">
import { RuleViolatingPolicy } from '@/services/v2/ClientReadinessService';
import { EllipsisVertical } from '@lucide/vue';

defineProps<{
  title: string;
  policies: RuleViolatingPolicy[];
}>();

const emit = defineEmits<{
  editPolicy: [policyId: number, mainPolicyNumber: string];
}>();
</script>

<template>
  <div
    class="collapse-arrow collapse overflow-visible rounded-lg bg-base-200 text-lg"
    :class="{ 'collapse-close': policies.length === 0 }">
    <input type="checkbox" />
    <div class="collapse-title flex justify-between">
      <div>{{ title }}</div>
      <div class="text-xl" :class="{ 'text-primary': policies.length > 0 }">
        {{ policies.length }}
      </div>
    </div>
    <div class="collapse-content">
      <table class="table bg-white">
        <tbody>
          <tr v-for="policy in policies" :key="policy.policyId">
            <td>
              <div class="flex items-center gap-2">
                <div class="text-base">
                  {{ policy.description }}
                </div>
                <div class="text-xs">({{ policy.mainPolicyNumber }})</div>
              </div>
            </td>
            <td class="text-end">
              <div class="dropdown">
                <div tabindex="0" role="button" class="btn btn-xs">
                  <EllipsisVertical :size="15" />
                </div>
                <ul tabindex="0" class="dropdown-content menu menu-xs rounded-lg bg-white shadow">
                  <li>
                    <a
                      class="whitespace-nowrap"
                      @click="emit('editPolicy', policy.policyId, policy.mainPolicyNumber)"
                      >Edit Policy</a
                    >
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
